'use client';
import PropTypes from 'prop-types';
import MarkdownParser from 'components/rich-text/markdown-parser';
import TrackedDownloadButton from 'components/controls/links/download-button/tracked-download-button';
import { Link } from 'src/navigation';
import { routeForDocument } from 'lib/routes';
import styles from './table-of-contents-links.module.scss';

const TableOfContentsLinks = ({ tableOfContents }) => {
	return (
		<ul className={styles.list}>
			{tableOfContents.map((publication) => {
				return (
					<li key={publication._id} className={styles.listItem}>
						<div className={styles.titleBox}>
							<div className={styles.title}>
								<MarkdownParser>{publication.title}</MarkdownParser>
							</div>
							<div className={styles.authorText}>
								{publication.authorsDisplay}
							</div>
						</div>
						<div className={styles.links}>
							<Link
								className={'button tertiary'}
								href={routeForDocument(publication)}
							>
								View Details
							</Link>
							{publication?.pdf && (
								<TrackedDownloadButton
									analytics={{
										contentType: 'MetPubs',
										contentBlock: 'Table of Contents',
										contentName: publication.title,
										contentId: publication._id,
									}}
									file={publication.pdf}
								/>
							)}
						</div>
					</li>
				);
			})}
		</ul>
	);
};

TableOfContentsLinks.propTypes = {
	tableOfContents: PropTypes.array,
};

export default TableOfContentsLinks;
